/* Stylesheet */

.pagination_container {
  display: flex;
  align-items: center;
}
